import { Component, OnInit, ChangeDetectorRef, AfterViewChecked, OnDestroy, ViewChild, AfterViewInit } from '@angular/core';
import {
  UserService,
  CampusWardsDataService,
  SortService,
  StudentListing,
  CampusWard,
  AcademicSession,
  HousingDataService,
  MemberInfo,
  CheckableStudentListing,
  HomeWardWithCheckAbleStudents,
  SortableChurchUnit, NavigationService, User
} from '../../shared';
import { LeaderComponent } from '../leader.component';
import { ComposeEmailDialogComponent } from './compose-email-dialog/compose-email-dialog.component';
import { EmailService } from '../../shared/services/email.service';
import { EmailRequest } from '../../shared/models/communications/email-request.model';
import { Observable, Subscription } from 'rxjs';
import { MatDialog, MatDialogConfig, MatDialogRef } from '@angular/material/dialog';
import { MatSlideToggle } from '@angular/material/slide-toggle';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatTabGroup } from '@angular/material/tabs';
import {MatSelectionListChange } from '@angular/material/list';
import { ActivatedRoute, Router } from '@angular/router';
import { finalize } from 'rxjs/operators';

@Component({
  selector: 'app-email',
  templateUrl: './email.component.html',
  styleUrls: ['./email.component.scss']
})
export class EmailComponent extends LeaderComponent implements OnInit, AfterViewChecked, OnDestroy {
  localWardMembers: CheckableStudentListing[] = [];
  campusWardMembers: CheckableStudentListing[] = [];
  selectedRecipients: CheckableStudentListing[] = [];
  user: Subscription;

  wardsWithAttendingStudents: HomeWardWithCheckAbleStudents[] = [];
  wardsWithNoneAttendingStudents: HomeWardWithCheckAbleStudents[] = [];

  academicSessions: AcademicSession[];
  selectedAcademicSession: AcademicSession;

  emailUser: User;
  ward: CampusWard;
  canSendEmail = true;

  EMAIL_SENT = 'Email sent successfully'
  EMAIL_SEND_FAILED = 'We were unable to send your email at this time. Please try again later'

  loadingSessions = true;
  loadingLocalStudents = true;
  loadingCampusStudents = true;
  loadingError = false;
  wardSelected = false;
  isInitialPageLoad = true;
  canChangeSessions = false;

  // For activating the right tab in the tab group and labelling
  firstTab = 'On-Campus Students';
  firstTabIndex = 0;
  secondTab = 'Local Students (atending)';
  secondTabIndex = 0;
  thirdTab = 'Local Students (not attending)';
  thirdTabIndex = 0;
  initialTab = this.firstTab;
  selectedTab = this.firstTab;
  tabCount = 0;

  @ViewChild('mainTabGroup', {static: true}) set tabGroup(group: MatTabGroup) {
    if (group) {
      this.tabCount = group._tabs.length;

      // set the tab to be selected
      switch (group._tabs.first.textLabel) {
        case this.firstTab:
          this.initialTab = this.firstTab;
          break;
        case this.secondTab:
          this.initialTab = this.secondTab;
          break;
        case this.thirdTab:
          this.initialTab = this.thirdTab;
          break;
      }
    }
  }

  constructor(
    protected userService: UserService,
    protected dialog: MatDialog,
    private wardService: CampusWardsDataService,
    private sorter: SortService,
    private housingService: HousingDataService,
    private route: ActivatedRoute,
    private router: Router,
    private cdRef: ChangeDetectorRef,
    private matDialog: MatDialog,
    private navService: NavigationService,
    private emailService: EmailService,
    private snackBar: MatSnackBar
  ) {
    super(userService, dialog);
  }

  ngOnInit() {
    super.ngOnInit();
    this.isInitialPageLoad = true;

    this.user = this.userService.user.subscribe(user => {
      this.emailUser = user;
      if (!this.emailUser.email || this.emailUser.email === '') {
        this.canSendEmail = false;
      } else {
        this.canSendEmail = true;
      }
    });

    if (this.isWardLeader()) {
      this.wardSelected = true;
      if (this.canSendEmail) {
        const loadCurrentSemester = true;
        this.loadStudents(this.getWard(), loadCurrentSemester);
      }
    } else {
      this.wardSelected = false;
    };
    this.loadAcademicSessions();
  }


  // to handle ExpressionChangedAfterItHasBeenChecked Error
  ngAfterViewChecked() {
    this.cdRef.detectChanges();
  }


  ngOnDestroy() {
    this.user.unsubscribe();
  }

  /**
   * Returns true if we finished loading students data
   * and didn't get anything back
   */
  noStudentsAvailable() {
    const finishedLoading = (!this.loadingCampusStudents && !this.loadingLocalStudents);
    const noContent = ((!this.campusWardMembers || this.campusWardMembers.length === 0)
      && (!this.wardsWithAttendingStudents || this.wardsWithAttendingStudents.length === 0)
      && (!this.wardsWithNoneAttendingStudents || this.wardsWithNoneAttendingStudents.length === 0));
    return (finishedLoading && noContent)
  }

  onTabChanged(event: any) {
    if (event && event.tab) {
      this.selectedTab = event.tab.textLabel;
    }
  }

  loadAcademicSessions() {
    this.housingService.getAcademicSessions()
      .pipe(
        finalize(() => (this.loadingSessions = false))
      )
      .subscribe(semesters => {
        this.setAcademicSessions(semesters);
        this.canChangeSessions = true;
      }, error => {
        this.loadingError = true;
      });
  }

  setAcademicSessions(academicSessions: AcademicSession[]) {
    var _academicSessions = academicSessions;
    this.academicSessions = [];
    academicSessions.sort(this.sorter.sortAcademicSessionsAsc);
    if (_academicSessions.length > 0) {
      this.selectedAcademicSession = _academicSessions[0];
      this.academicSessions.push(_academicSessions[0])
    }
    if (_academicSessions.length > 1) {
      this.academicSessions.push(_academicSessions[1]);
    }
  }


  clearStudents() {
    this.localWardMembers = []
    this.campusWardMembers = [];
    this.selectedRecipients = [];

    this.wardsWithAttendingStudents = [];
    this.wardsWithNoneAttendingStudents = [];
  }

  onAcademicSessionSelect() {
  }

  getStudentsFromSession() {
    this.clearRecipients();
    this.clearStudents();
    const loadCurrentSemester = false;

    this.loadStudents(this.getWard(), loadCurrentSemester);
  }

  /**
   * Handles a stake leader wanting to email students of a ward in their stake.
   */
  onWardSelected(ward: CampusWard, forceLoad = false) {
    // we don't want to load a ward automatically when the page loads since the first
    // item is auto selected we want the user to select a ward first.
    if (this.isInitialPageLoad && !forceLoad) {
      this.isInitialPageLoad = false;
      return;
    } else {
      this.isInitialPageLoad = false;
    }
    this.campusWardMembers = []
    this.wardsWithAttendingStudents = [];
    this.wardsWithNoneAttendingStudents = [];

    const loadCurrentSemester = true;

    this.wardSelected = true;
    this.loadStudents(ward, loadCurrentSemester);
  }

  loadStudents(ward: CampusWard, loadCurrentSemester: boolean) {
    if (ward) {
      this.ward = ward;
      this.loadLocalStudents();
      this.loadCampusWardMembers(loadCurrentSemester);
    }
  }


  /**
   * Loads the ward's information: assigned local wards and possible students for each one.
   */
  private loadLocalStudents() {
    // only load students in singles wards
    if (this.ward == null || this.ward.isForMarriedStudents) {
      return;
    }

    this.loadingLocalStudents = true;
    this.loadingError = false;

    const localStudentLoadRequestObservable: Observable<HomeWardWithCheckAbleStudents[]> = this.wardService.getPossibleCheckableLocalStudents(this.ward.campusWardId);

    localStudentLoadRequestObservable.subscribe(results => {
      // sort first, then transform to an object that lets us track what students the user has selected
      results.sort(this.sorter.sortHomeWardWithStudentsAsc);
      this.filterWardsWithAttendingStudents(results);

      this.loadingLocalStudents = false;
    }, error => {
      this.loadingError = true;
      this.loadingLocalStudents = false;
    });
  }

  /**
   * Get on campus students
   */
  private loadCampusWardMembers(loadCurrentSemester: boolean) {
    if (this.ward == null) {
      return;
    }

    const term: string = this.selectedAcademicSession ? this.selectedAcademicSession.code : null;
    const year: number = this.selectedAcademicSession ? this.selectedAcademicSession.year : 0;
    const excludeNonAttendingLocalStudents = false;
    const loadOnlyBasicData = true;

    if (!loadCurrentSemester && (term === null || year === 0)) {
      throw ("Error: Term and year must be provided");
    }

    let onCampusMembersRequestObservable: Observable<MemberInfo[]> = null;
    this.loadingCampusStudents = true;

    if (loadCurrentSemester) {
      onCampusMembersRequestObservable = this.wardService.getCurrentBasicCampusWardDirectory(this.ward.campusWardId);
    } else {
      onCampusMembersRequestObservable = this.wardService.getCampusWardDirectory(this.ward.campusWardId, term, year, excludeNonAttendingLocalStudents, loadOnlyBasicData);
    }

    onCampusMembersRequestObservable.subscribe(results => {
      this.loadingCampusStudents = false;
      if (results) {
        this.campusWardMembers = this.transFormMemberInfoToCheckableStudentListing(results);
      }
    }, error => {
      this.loadingCampusStudents = false;
    });
  }



  /**
   * Add students to separate lists based on whether they're
   * mark as attending their assigned campus ward
   * @param data datasource
   */
  private filterWardsWithAttendingStudents(data: HomeWardWithCheckAbleStudents[]) {
    if (!data) {
      return;
    }

    data.forEach(ward => {
      ward.students.forEach(student => {
        if (student.isAttending) {
          this.addStudentToWard(student, ward.homeWard, true);
        } else {
          this.addStudentToWard(student, ward.homeWard, false)
        }
      });
    });
    this.sortStudents();
  }

  /**
   * Helper function. Add student to a ward group
   * @param student student
   * @param ward ward
   * @param isAttending attending
   */
  private addStudentToWard(student: CheckableStudentListing, ward: SortableChurchUnit, isAttending) {
    if (!student || !ward) {
      return;
    }

    let wardGroup: HomeWardWithCheckAbleStudents[] = []
    // check if the ward already exists in the correct array
    if (isAttending) {
      wardGroup = this.wardsWithAttendingStudents;
    } else {
      wardGroup = this.wardsWithNoneAttendingStudents;
    }

    // add the ward
    const index = wardGroup.findIndex(w => w.homeWard.name === ward.name);
    if (index < 0) {
      const newUnit = new HomeWardWithCheckAbleStudents();
      newUnit.homeWard = ward;
      student.checked = false;
      newUnit.students = [student];

      wardGroup.push(newUnit);
    } else {
      wardGroup[index].students.push(student);
    }
  }

  sortStudents() {
    this.wardsWithAttendingStudents.sort(this.sorter.sortHomeWardWithCheckableStudentsAsc);
    this.wardsWithNoneAttendingStudents.sort(this.sorter.sortHomeWardWithCheckableStudentsAsc);

    this.wardsWithAttendingStudents.forEach(w => {
      w.students.sort(this.sorter.sortCheckableStudentListingsAsc);
    });

    this.wardsWithNoneAttendingStudents.forEach(w => {
      w.students.sort(this.sorter.sortCheckableStudentListingsAsc);
    });

    this.campusWardMembers.sort(this.sorter.sortCheckableStudentListingsAsc);
  }


  /**
   * Convert MemberInfo array to StudentListing array so that we'll have the same
   * data type to work with.
   * @param members MemberInfo
   */
  private transFormMemberInfoToCheckableStudentListing(members: MemberInfo[]) {
    if (!members) {
      return;
    }
    const studentListings: CheckableStudentListing[] = [];
    for (const member of members) {
      const studentListing = new StudentListing();
      studentListing.iNumber = member.iNumber;
      studentListing.firstName = member.firstName;
      studentListing.lastName = member.lastName;
      studentListing.privacyMessage = member.privacyMessage;
      studentListing.email = member.email;
      studentListing.gender = null;
      studentListing.isAttending = true;

      const checkableListing = new CheckableStudentListing(studentListing);

      studentListings.push(checkableListing);
    }

    studentListings.sort(this.sorter.sortCheckableStudentListingsAsc);

    return studentListings;
  }

  /**
   * Handles the click from the recipient list and removes them from the list.
   * @param event 
   */
  removeIndividualRecipient(event: MatSelectionListChange) {
    for (const option of event.options) {
      this.removeRecipient(option.value);
    }
  }

  /**
   * Remove recipient from the recipients list
   * @param student student
   */
  removeRecipient(student: CheckableStudentListing) {
    const selectedIndex = this.selectedRecipients.findIndex(s => s.iNumber === student.iNumber);
    const recipient = this.selectedRecipients[selectedIndex];
    if (recipient) {
      recipient.checked = false;
    }

    this.selectedRecipients.splice(selectedIndex, 1);

    let groupIndex = this.getWardIndex(student.iNumber, this.wardsWithAttendingStudents);
    if (groupIndex >= 0) {
      const wardIndex = this.wardsWithAttendingStudents[groupIndex].students.findIndex(s => s.iNumber === student.iNumber);
      if (wardIndex >= 0) {
        this.wardsWithAttendingStudents[groupIndex].students[wardIndex].checked = false;
      }
      return;
    }

    // try to find it in none attending students ward groups
    groupIndex = this.getWardIndex(student.iNumber, this.wardsWithNoneAttendingStudents);
    if (groupIndex >= 0) {
      const wardIndex = this.wardsWithNoneAttendingStudents[groupIndex].students.findIndex(s => s.iNumber === student.iNumber);
      if (wardIndex >= 0) {
        this.wardsWithNoneAttendingStudents[groupIndex].students[wardIndex].checked = false;
      }
      return;
    }

    // try to find the student in the campusWardStudents
    const index = this.campusWardMembers.findIndex(s => s.iNumber === student.iNumber);
    if (index >= 0) {
      const wardIndex = this.campusWardMembers.findIndex(s => s.iNumber === student.iNumber);
      if (wardIndex >= 0) {
        this.campusWardMembers[wardIndex].checked = false;
      }
      return;
    }

  }

  /**
   * Handles the individual click on the students list.
   * @param event 
   */
  addIndividualRecipient(event: MatSelectionListChange) {
    for (const option of event.options) {
      if (option.value.checked) {
        this.removeRecipient(option.value);
      } else {
        this.addRecipient(option.value);
      }
    }
  }


  /**
   * Add a student to the recipient list
   * @param student student
   */
  addRecipient(student) {
    if (student) {
      student.checked = true;
      this.selectedRecipients.push(student);
      this.selectedRecipients.sort(this.sorter.sortCheckableStudentListingsAsc);
    }
  }

  /**
   * Helper function: Get the index of a ward group in a list
   * @param studentInumber inumber
   * @param wardGroup wardgroup
   */
  getWardIndex(studentInumber: string, wardGroup: HomeWardWithCheckAbleStudents[]) {
    const index = wardGroup.findIndex(w => {
      const studentIdex = w.students.findIndex(s => s.iNumber === studentInumber);
      return (studentIdex >= 0);
    })

    return index;
  }

  togleSelectAllCampusWardMembers(toggle: MatSlideToggle) {
    if (toggle.checked) {
      this.addAllCampusStudentsToRecipients()
    } else {
      this.removeAllCampusStudentsFromRecipientsList();
    }
  }

  togleSelectAllLocalWardMembers(wardGroup, toggle: MatSlideToggle) {
    if (toggle.checked) {
      this.addAllLocalWardMembersToRecipients(wardGroup)
    } else {
      this.removeAllLocalWardMembersFromRecipients(wardGroup);
    }
  }

  addAllCampusStudentsToRecipients() {
    const lenght = this.campusWardMembers.length;

    for (let i = 0; i < lenght; i++) {
      const student = this.campusWardMembers[i];

      // make sure we didn't add it the student already
      if (this.selectedRecipients) {
        const index = this.selectedRecipients.findIndex(s => s.iNumber === student.iNumber);
        if (index < 0) {
          this.addRecipient(student)
        }
      }
    }
  }

  /**
   * Helper function: Add a list of students from a group to
   * the email recipient list
   * @param studentGroup student group
   */
  addAllLocalWardMembersToRecipients(studentGroup) {
    if (!studentGroup || studentGroup.length <= 0) {
      return;
    }

    studentGroup.students.forEach(s => {
      const index = this.selectedRecipients.findIndex(student => student.iNumber === s.iNumber);
      if (index < 0) {
        this.addRecipient(s)
      }
    });
  }

  /**
   * Remove all on campus students from the recipients list
   */
  removeAllCampusStudentsFromRecipientsList() {
    if (this.campusWardMembers) {
      for (const student of this.campusWardMembers) {
        this.removeRecipient(student);
      }
    }
  }


  /**
   * Helper function: Removes all students in a local ward group from
   * the email recipient list
   * @param studentGroup student group
   */
  removeAllLocalWardMembersFromRecipients(studentGroup) {
    if (studentGroup) {
      studentGroup.students.forEach(s => this.removeRecipient(s));
    }
  }

  /**
   * Returns true if all the students in the group are checked
   * @param studentGroup studentgroup
   * @param isFlatGroup if its a flat list or have sub groups with students
   */
  isSelectedAll(studentGroup, isFlatGroup) {
    let allSelected = true;
    if (isFlatGroup) {
      if (studentGroup.length <= 0) {
        allSelected = false;
      }
      allSelected = this.allStudentsSelected(studentGroup);
    } else {
      if (studentGroup.length <= 0 || studentGroup.students.length <= 0) {
        allSelected = false;
      }
      allSelected = this.allStudentsSelected(studentGroup.students);
    }
    return allSelected;
  }

  /**
   * Helper function: Returns true if all the students in the list
   * are checked.
   * @param studentList students list
   */
  allStudentsSelected(studentList) {
    if (!studentList || studentList.length === 0) {
      return false;
    }

    for (let i = 0; i < studentList.length; i++) {
      if (!studentList[i].checked) {
        return false;
      }
    }

    return true;
  }

  clearRecipients() {
    if (!this.selectedRecipients) {
      return;
    }
    // using the list directly results in a situation where the length is less
    // than the counter since the length is being reduced as each item is removed.
    // this results in all recipients not being removed.
    const students = this.selectedRecipients.slice();
    students.forEach(s => this.removeRecipient(s));
  }

  writeEmail() {
    const recipients = this.selectedRecipients.map(s => s.email);
    const dialogRef = this.openEditDialog(recipients);
    const request = new EmailRequest();

    const onEmailSendEvent = dialogRef.componentInstance.onSendEmail.subscribe(data => {
      request.message = data.message;
      request.subject = data.subject;
      request.bcc = data.recipients;
      request.from = this.emailUser.email;
      request.cc = '';
      request.to = '';

      this.sendEmail(request);
    })
  }

  private sendEmail(emailRequest: EmailRequest) {
    if (!emailRequest) {
      return;
    }

    this.emailService.sendEmail(emailRequest).subscribe(data => {
      this.showSnackBarMessage(this.EMAIL_SENT);
    }, error => {
      this.showSnackBarMessage(this.EMAIL_SEND_FAILED)
    });
  }

  showSnackBarMessage(content: string) {
    const snack = this.snackBar.open(content, 'close',
      {
        duration: 5000,
      });

  }

  onFixMissingEmailAddress() {
    this.router.navigate(['/leader/ward']);
  }



  /**
   * Opens a dialog box to compose an email message
   * @param recipients recipients list. array of email address strings. Required
   * @returns MatDialog reference
   */
  private openEditDialog(recipients: string[]): MatDialogRef<ComposeEmailDialogComponent> {
    if (!recipients) {
      return;
    }
    const dialogConfig = new MatDialogConfig();

    dialogConfig.disableClose = true;

    dialogConfig.data = { recipients: recipients, user: this.emailUser }

    dialogConfig.height = '60%';
    dialogConfig.width = '70%';

    return this.matDialog.open(ComposeEmailDialogComponent, dialogConfig);
  }

}
